export default __webpack_public_path__ + "static/media/monitoring_black_gray.25c02046.svg";